export enum EntityFileTypeEnum {
    Other = 0,
    ProfilePhoto = 1,
    CoverPhoto = 2
}